<template>
  <router-view />
</template>

<script>
export default {
  name: 'Users'
};
</script>

<style lang="scss" scoped></style>
